// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"69b7a744","87":"4d65d565","112":"10ccd1dc","220":"868edda5","249":"f361ab0d","359":"cbed454b","434":"50d8717a","488":"a25897cc","545":"5314a2b7","685":"836c2be1","702":"a1495301","824":"c6a453d6","847":"d11d6d43","860":"67dae7d6","915":"adea101d"}[chunkId] + ".chunk.js";
};